import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Wkład własny to jeden z największych progów na drodze do własnego mieszkania. Banki wymagają,
        aby kredytobiorca posiadał określoną część wartości nieruchomości w gotówce. Ile dokładnie
        potrzebujesz i czy da się to obejść? Wyjaśniamy krok po kroku.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Ile wynosi minimalny wkład własny?</h2>
      <p>
        Zgodnie z rekomendacją S wydaną przez Komisję Nadzoru Finansowego (KNF), minimalny wkład
        własny przy kredycie hipotecznym wynosi <strong>20% wartości nieruchomości</strong>. Oznacza
        to, że przy zakupie mieszkania za 500 000 zł musisz dysponować kwotą 100 000 zł.
      </p>
      <p className="mt-3">
        Wiele banków umożliwia jednak uzyskanie kredytu z wkładem własnym na poziomie <strong>10%</strong>,
        pod warunkiem wykupienia dodatkowego ubezpieczenia niskiego wkładu własnego. To ubezpieczenie
        podwyższa koszt kredytu, ale pozwala szybciej wejść na rynek nieruchomości, zamiast dalej <BlogLink slug="kredyt-czy-wynajem">wynajmować</BlogLink>.
      </p>

      <div className="bg-muted/50 rounded-xl p-4 mt-4">
        <p className="font-semibold mb-2">Przykład — mieszkanie za 500 000 zł:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Wkład 20% = <strong>100 000 zł</strong> — kredyt na 400 000 zł</li>
          <li>Wkład 10% = <strong>50 000 zł</strong> — kredyt na 450 000 zł + ubezpieczenie</li>
        </ul>
      </div>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20}>
          Oblicz ratę przy 20% wkładu własnego
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Dlaczego wyższy wkład się opłaca?</h2>
      <p>
        Im wyższy wkład własny, tym korzystniejsze warunki kredytu. Banki nagradzają klientów,
        którzy wnoszą więcej gotówki, ponieważ ryzyko dla banku jest mniejsze.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Niższa marża</strong> — banki oferują lepsze <BlogLink slug="co-to-jest-wibor">oprocentowanie</BlogLink> przy wkładzie 20% lub wyższym</li>
        <li><strong>Brak dodatkowego ubezpieczenia</strong> — oszczędzasz na ubezpieczeniu niskiego wkładu</li>
        <li><strong>Niższa rata</strong> — mniejsza kwota kredytu oznacza mniejsze miesięczne obciążenie</li>
        <li><strong>Mniej zapłaconych odsetek</strong> — w skali 25-30 lat różnica sięga dziesiątek tysięcy złotych</li>
      </ul>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={10}>
          Porównaj ratę przy 10% wkładu
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Skąd wziąć wkład własny?</h2>
      <p>
        Zebranie 20% wartości nieruchomości to poważne wyzwanie, szczególnie w dużych miastach.
        Oto sprawdzone sposoby na zgromadzenie potrzebnych środków:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Oszczędności</strong> — systematyczne odkładanie na koncie oszczędnościowym lub lokacie</li>
        <li><strong>Darowizna od rodziny</strong> — banki akceptują darowiznę jako wkład własny (potrzebna umowa darowizny)</li>
        <li><strong>Książeczka mieszkaniowa</strong> — jeśli posiadasz starą książeczkę, możesz uzyskać premię gwarancyjną</li>
        <li><strong>Działka lub inna nieruchomość</strong> — posiadana nieruchomość może stanowić zabezpieczenie zamiast gotówki</li>
        <li><strong>Programy rządowe</strong> — warto śledzić aktualne programy wsparcia mieszkalnictwa</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Wkład własny a koszty dodatkowe</h2>
      <p>
        Pamiętaj, że wkład własny to nie jedyny wydatek przy zakupie mieszkania. Do budżetu musisz
        doliczyć dodatkowe koszty:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Prowizja banku</strong> — od 0% do 2% wartości kredytu</li>
        <li><strong>Opłata notarialna</strong> — taksa notarialna zależna od wartości transakcji</li>
        <li><strong>Podatek PCC</strong> — 2% przy zakupie z rynku wtórnego</li>
        <li><strong>Wycena nieruchomości</strong> — koszt operatu szacunkowego (300-800 zł)</li>
        <li><strong>Ubezpieczenie</strong> — ubezpieczenie nieruchomości, a niekiedy także na życie</li>
      </ul>
      <p className="mt-3">
        W praktyce oprócz wkładu własnego warto mieć dodatkowe <strong>3-5% wartości nieruchomości</strong> na
        pokrycie wszystkich kosztów transakcyjnych.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie</h2>
      <p>
        Minimalny wkład własny to 10-20% wartości nieruchomości, ale im więcej wnosisz — tym lepsze
        warunki kredytu otrzymasz. Zanim zaczniesz szukać mieszkania, sprawdź w kalkulatorze ile
        wyniesie Twoja rata przy różnych poziomach wkładu własnego. Nie zapomnij o dodatkowych
        kosztach, które mogą wynieść kilka procent wartości nieruchomości.
      </p>
      <p className="mt-3">
        Jeśli kupujesz <strong>pierwsze mieszkanie</strong>, wkład własny to tylko jeden z kilku
        etapów. Pełną ścieżkę od zdolności kredytowej do aktu notarialnego — z dokumentami
        i harmonogramem 2-4 miesięcy — opisujemy w poradniku{' '}
        <BlogLink slug="jak-dostac-kredyt-hipoteczny-na-pierwsze-mieszkanie">jak dostać kredyt
        hipoteczny na pierwsze mieszkanie</BlogLink>.
      </p>

      <div className="mt-4">
        <CalculatorLink propertyPrice={400000} downPaymentPercent={20} section="affordability">
          Sprawdź na co Cię stać z kalkulatorem RatyGo
        </CalculatorLink>
      </div>
    </>
  )
}
